import React from 'react';
import {MENU_INFO} from '../../../../../../config/TextContent';
import MenuItem from '../MenuItem';

const ElementInfo = props => {
    return (
        <MenuItem 
            name={MENU_INFO}
            link={props.link}
            img='/img/icons/info-green.svg' 
            active={props.active}
            onClick={props.onClick}
        />
    );
}

export default ElementInfo;
